jQuery(function($) {
    $(document).on("focus", ".sidebar-form-body .ninja-forms-field", function() {
        $(this).parents('.field-wrap').addClass('nf-active');
    });
    $(document).on("blur", ".sidebar-form-body .ninja-forms-field", function() {
        if ($(this).val() == '') {
            $(this).parents('.field-wrap').removeClass('nf-active');
        }
    });
    $(document).on("focus", ".ninja-forms-field", function() {
        $(this).parents('.field-wrap').addClass('nf-active');
    });
    $(document).on("blur", ".ninja-forms-field", function() {
        if ($(this).val() == '') {
            $(this).parents('.field-wrap').removeClass('nf-active');
        }
    });
});